module.exports = "<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-drop/ng4-files-drop.component.html
// module id = ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-drop/ng4-files-drop.component.html
// module chunks = main